import { render } from "./animatedCurrency.vue?vue&type=template&id=4a8bca72&ts=true"
import script from "./animatedCurrency.vue?vue&type=script&lang=ts"
export * from "./animatedCurrency.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\fpbillions\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__